(() => {
  const ignored = new Set(['SCRIPT','STYLE','TEXTAREA','INPUT','OPTION']);
  const normalizeNode = (node) => {
    if (!node || node.nodeType !== Node.TEXT_NODE || !node.nodeValue) return;
    if (ignored.has(node.parentElement?.tagName)) return;
    if (node.nodeValue.includes('د.أ') || node.nodeValue.includes('JOD')) {
      node.nodeValue = node.nodeValue.replace(/د\.أ|JOD/g, 'JD');
    }
  };
  const normalizeCurrency = (root) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) normalizeNode(node);
  };
  const updateAnnouncementHeight = () => {
    const bar = document.querySelector('.announcement');
    document.documentElement.style.setProperty('--announcement-height', `${bar ? Math.ceil(bar.getBoundingClientRect().height) : 0}px`);
  };
  const chooseDefaultWeight = () => {
    document.querySelectorAll('[data-weight-select]').forEach((select) => {
      const option = [...select.options].find((item) => item.value === '500 غرام' && !item.disabled);
      if (option && select.value !== option.value) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  };
  const init = () => {
    normalizeCurrency(document.body);
    updateAnnouncementHeight();
    chooseDefaultWeight();
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') normalizeNode(mutation.target);
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) normalizeNode(node);
          else if (node.nodeType === Node.ELEMENT_NODE && !ignored.has(node.tagName)) normalizeCurrency(node);
        });
      });
    });
    observer.observe(document.body, { subtree: true, childList: true, characterData: true });
    window.addEventListener('resize', updateAnnouncementHeight, { passive: true });
    if ('ResizeObserver' in window) {
      const bar = document.querySelector('.announcement');
      if (bar) new ResizeObserver(updateAnnouncementHeight).observe(bar);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

(() => {
  const fillerWords = new Set([
    'ضمه','ضمة','ربطه','ربطة','حبه','حبة','كيلو','كغم','جرام','غرام','نص','نصف',
    'واحد','واحده','واحدة','من','بدي','اريد','أريد','بدّي'
  ]);

  const normalizeArabic = (value) => String(value || '')
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u064B-\u065F\u0670\u06D6-\u06ED]/g, '')
    .replace(/ـ/g, '')
    .replace(/[أإآٱ]/g, 'ا')
    .replace(/ى/g, 'ي')
    .replace(/ة/g, 'ه')
    .replace(/ؤ/g, 'و')
    .replace(/ئ/g, 'ي')
    .replace(/[^\u0600-\u06FFa-z0-9\s-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const queryTokens = (value) => normalizeArabic(value)
    .split(' ')
    .filter((token) => token.length > 1 && !fillerWords.has(token));

  const distance = (a, b) => {
    if (a === b) return 0;
    if (!a.length) return b.length;
    if (!b.length) return a.length;
    const row = Array.from({ length: b.length + 1 }, (_, index) => index);
    for (let i = 1; i <= a.length; i += 1) {
      let previous = row[0];
      row[0] = i;
      for (let j = 1; j <= b.length; j += 1) {
        const saved = row[j];
        row[j] = Math.min(
          row[j] + 1,
          row[j - 1] + 1,
          previous + (a[i - 1] === b[j - 1] ? 0 : 1)
        );
        previous = saved;
      }
    }
    return row[b.length];
  };

  const tokenScore = (needle, haystack) => {
    if (!needle || !haystack) return 0;
    if (needle === haystack) return 1;
    if (haystack.startsWith(needle) || needle.startsWith(haystack)) return 0.94;
    if (haystack.includes(needle) || needle.includes(haystack)) return 0.9;
    const similarity = 1 - (distance(needle, haystack) / Math.max(needle.length, haystack.length));
    return similarity >= 0.6 ? similarity * 0.88 : 0;
  };

  const root = window.Shopify?.routes?.root || '/';
  let productsPromise;

  const loadProducts = () => {
    if (!productsPromise) {
      productsPromise = fetch(`${root}products.json?limit=250`, { headers: { Accept: 'application/json' } })
        .then((response) => response.ok ? response.json() : Promise.reject(new Error('products')))
        .then((data) => (data.products || []).map((product) => {
          const tags = Array.isArray(product.tags) ? product.tags.join(' ') : (product.tags || '');
          const searchable = normalizeArabic([
            product.title,
            product.handle,
            tags,
            ...(product.variants || []).map((variant) => variant.title)
          ].join(' '));
          return {
            title: product.title,
            url: `${root}products/${product.handle}`,
            image: product.images?.[0]?.src || '',
            searchable,
            tokens: searchable.split(' ').filter(Boolean)
          };
        }))
        .catch(() => []);
    }
    return productsPromise;
  };

  const rankProducts = (value, products) => {
    const tokens = queryTokens(value);
    const whole = normalizeArabic(value);
    if (!tokens.length) return [];

    return products.map((product) => {
      let total = 0;
      let matched = 0;
      tokens.forEach((queryToken) => {
        let best = 0;
        product.tokens.forEach((productToken) => {
          best = Math.max(best, tokenScore(queryToken, productToken));
        });
        if (product.searchable.includes(queryToken)) best = Math.max(best, 0.95);
        if (best > 0.55) matched += 1;
        total += best;
      });

      let score = total / tokens.length;
      if (tokens.every((token) => product.searchable.includes(token))) score += 0.12;
      if (whole && product.searchable.includes(whole)) score += 0.18;
      if (matched !== tokens.length) score *= 0.65;
      return { ...product, score };
    })
      .filter((product) => product.score >= 0.5)
      .sort((a, b) => b.score - a.score)
      .slice(0, 6);
  };

  const addHiddenInput = (form, name, value) => {
    if (form.querySelector(`input[name="${name}"]`)) return;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };

  const setup = () => {
    const forms = [...document.querySelectorAll('.global-product-search, .search-form')];
    if (!forms.length) return;

    const style = document.createElement('style');
    style.textContent = `
      .smart-search-host{position:relative}
      .smart-search-results{position:absolute;top:calc(100% + 7px);right:0;left:0;z-index:1000;background:#fff;border:1px solid rgba(23,48,31,.12);border-radius:14px;box-shadow:0 14px 38px rgba(18,44,28,.16);overflow:hidden;display:none;text-align:right}
      .smart-search-results.is-open{display:block}
      .smart-search-result{display:flex;align-items:center;gap:10px;padding:10px 12px;color:#172019;text-decoration:none;border-bottom:1px solid rgba(23,48,31,.08)}
      .smart-search-result:last-of-type{border-bottom:0}
      .smart-search-result:hover,.smart-search-result:focus{background:#f3f8f1}
      .smart-search-result img{width:46px;height:46px;border-radius:9px;object-fit:contain;background:#fff;flex:0 0 46px}
      .smart-search-result__placeholder{width:46px;height:46px;border-radius:9px;background:#f2f5f1;flex:0 0 46px}
      .smart-search-result span:last-child{font-weight:800}
      .smart-search-hint{padding:9px 12px;font-size:.76rem;color:#6d756f;background:#f8faf7}
    `;
    document.head.appendChild(style);

    forms.forEach((form) => {
      const input = form.querySelector('input[type="search"][name="q"]');
      if (!input) return;

      addHiddenInput(form, 'type', 'product');
      addHiddenInput(form, 'options[prefix]', 'last');
      form.classList.add('smart-search-host');
      input.setAttribute('autocomplete', 'off');

      const box = document.createElement('div');
      box.className = 'smart-search-results';
      box.setAttribute('role', 'listbox');
      form.appendChild(box);

      let latestResults = [];
      let timer;

      const close = () => {
        box.classList.remove('is-open');
      };

      const render = (results) => {
        latestResults = results;
        box.replaceChildren();
        if (!results.length) {
          close();
          return;
        }

        results.forEach((item) => {
          const link = document.createElement('a');
          link.className = 'smart-search-result';
          link.href = item.url;
          link.setAttribute('role', 'option');

          if (item.image) {
            const image = document.createElement('img');
            image.src = item.image;
            image.alt = '';
            image.loading = 'lazy';
            link.appendChild(image);
          } else {
            const placeholder = document.createElement('span');
            placeholder.className = 'smart-search-result__placeholder';
            link.appendChild(placeholder);
          }

          const title = document.createElement('span');
          title.textContent = item.title;
          link.appendChild(title);
          box.appendChild(link);
        });

        const hint = document.createElement('div');
        hint.className = 'smart-search-hint';
        hint.textContent = 'بحث ذكي: اكتب جزءاً من الاسم، أو اكتب مثلاً ضمة بقدونس، وحتى الخطأ الإملائي البسيط بنحاول نطابقه.';
        box.appendChild(hint);
        box.classList.add('is-open');
      };

      const update = async () => {
        const value = input.value.trim();
        if (value.length < 2) {
          render([]);
          return [];
        }
        const products = await loadProducts();
        const results = rankProducts(value, products);
        render(results);
        return results;
      };

      input.addEventListener('input', () => {
        clearTimeout(timer);
        timer = window.setTimeout(update, 120);
      });
      input.addEventListener('focus', update);

      form.addEventListener('submit', async (event) => {
        const value = input.value.trim();
        if (!value) return;
        event.preventDefault();
        clearTimeout(timer);
        const products = await loadProducts();
        const results = rankProducts(value, products);
        const first = results[0];
        const second = results[1];
        const clearWinner = first && first.score >= 0.68 && (!second || first.score - second.score >= 0.1);
        if (clearWinner) {
          window.location.href = first.url;
          return;
        }
        HTMLFormElement.prototype.submit.call(form);
      });

      document.addEventListener('click', (event) => {
        if (!form.contains(event.target)) close();
      });

      if (input.value.trim().length >= 2) update();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
})();
